import WIDGETS from './widgets';

export default {
	name: 'booking_meeting',
	spacing: 2,
	sx: { width: '100%' },
	widgets: [{ content: WIDGETS.BOOKING_OVERVIEW, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
